var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70184 9.85162C5.55784 9.85162 5.41384 9.79688 5.30434 9.68663C5.08459 9.46688 5.08459 9.11138 5.30434 8.89163L8.89834 5.29763C9.11809 5.07787 9.47359 5.07787 9.69334 5.29763C9.91309 5.51738 9.91309 5.87287 9.69334 6.09262L6.09934 9.68663C5.98984 9.79688 5.84584 9.85162 5.70184 9.85162",
    fill: "#A0ACB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29737 9.85538C9.15337 9.85538 9.00937 9.80063 8.89987 9.69038L5.30287 6.09263C5.08312 5.87288 5.08312 5.51738 5.30287 5.29763C5.52337 5.07787 5.87887 5.07787 6.09787 5.29763L9.69487 8.89538C9.91462 9.11513 9.91462 9.47063 9.69487 9.69038C9.58537 9.80063 9.44062 9.85538 9.29737 9.85538",
    fill: "#A0ACB9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24875 1.125C2.35125 1.125 1.125 2.42475 1.125 4.437V10.563C1.125 12.5752 2.35125 13.875 4.24875 13.875H10.7498C12.648 13.875 13.875 12.5752 13.875 10.563V4.437C13.875 2.42475 12.648 1.125 10.7505 1.125H4.24875ZM10.7498 15H4.24875C1.707 15 0 13.2165 0 10.563V4.437C0 1.7835 1.707 0 4.24875 0H10.7505C13.2922 0 15 1.7835 15 4.437V10.563C15 13.2165 13.2923 15 10.7498 15V15Z",
    fill: "#A0ACB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSquare);
export default __webpack_public_path__ + "static/media/closeSquare.ed8a9930df5aee37c36abf124c2bff65.svg";
export { ForwardRef as ReactComponent };